export default __webpack_public_path__ + "static/media/TechM1.d7005b83.jpg";